import React, { forwardRef, useMemo } from "react";

import { InputAdornment } from "./InputAdornment";
import { InputNumber, InputNumberProps } from "./InputNumber";
import { Typography } from "../Typography/Typography";

export interface IInputCurrency
  extends Omit<InputNumberProps, "align" | "limit"> {
  currency: string;
}

export const InputCurrency = forwardRef<HTMLInputElement, IInputCurrency>(
  (
    { currency, size, startAdornment, endAdornment, disabled, ...rest },
    ref
  ) => {
    const variant = useMemo(() => {
      if (size === "biggest") {
        return "Header 2";
      }
      if (size === "big") {
        return "Body 1";
      }
      return "Body 2";
    }, [size]);

    const weight = useMemo(() => {
      return size === "biggest" ? "bold" : "regular";
    }, [size]);

    return (
      <InputNumber
        size={size}
        align="right"
        ref={ref}
        disabled={disabled}
        endAdornment={
          endAdornment && (
            <InputAdornment disablePointerEvents={disabled}>
              {endAdornment}
            </InputAdornment>
          )
        }
        {...rest}
        startAdornment={
          <InputAdornment disablePointerEvents={disabled}>
            <Typography variant={variant} weight={weight}>
              {currency}
            </Typography>
            {startAdornment}
          </InputAdornment>
        }
      />
    );
  }
);

InputCurrency.displayName = "InputCurrency";
